/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_NoteInputs */

const en_lg_search_note = /** @type {(inputs: Lg_Search_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search terms are not stored in the page address or an application search history. Search excludes temporary nearby chat, recordings, and private provider account data.`)
};

const id_lg_search_note = /** @type {(inputs: Lg_Search_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata kunci tidak disimpan ke alamat halaman atau riwayat pencarian aplikasi. Pencarian ini tidak mencakup chat sekitar yang sementara, rekaman, atau data akun provider privat.`)
};

/**
* | output |
* | --- |
* | "Search terms are not stored in the page address or an application search history. Search excludes temporary nearby chat, recordings, and private provider acc..." |
*
* @param {Lg_Search_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_note = /** @type {((inputs?: Lg_Search_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_note(inputs)
	return en_lg_search_note(inputs)
});